module.exports = __webpack_public_path__ + "img/file-search-02.13f20559.svg";